import type { FaireProductEntity } from "../../entity_types/product";

export const p_5yd5295h30: FaireProductEntity = {
  token: "p_5yd5295h30",
  type: "product",
  name: "Pistachio Nut 1/2 lb. Fudge Bar",
  brandToken: "b_5021dx08mu",
  brandName: "Valley Fudge & Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/213ac56b40f674a947f6d00d045892eec89687e77b16792125ced68ffb3c0791.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82e23ec5883ee3d6e949b55ed1cd2edac972d02b66a3036dcf5b8c4251b175d9.jpeg",
    "https://cdn.faire.com/fastly/b994c458bd414c6ecec4649962f797dd58ed4550cbfebf76ce43a13c39c9cbbd.png",
  ],
  priceDollars: 6.86,
  description:
    "Our Fudge is always made with  fresh high quality ingredients, including 100% Real Wisconsin Butter! Sweet, salty and so yummy -- This sweet and creamy, Vanilla Fudge is loaded with lots of salty and crunchy pistachios. It makes a superb flavor that's sure to satisfy your craving for something sweet AND something salty!\n\nWholesale Message: To keep it simple and convenient for your business, we sell fudge by the individual package. This means you can purchase as many packages of any flavor as you would like. There is no limit required. The more fudge packages, the merrier!\n\nSale Shelf Life: We make all fudge fresh to order and ship it upon packaging. This provides 7-8 weeks of sale shelf life for your company.\n\nMerchandising Your Fudge: Your fudge is best merchandised at room temperature and out of direct sunlight.\n",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:46.565Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
